export const CreateUserIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M10.6668 14V12.6667C10.6668 11.9594 10.3859 11.2811 9.88578 10.781C9.38568
       10.281 8.70741 10 8.00016 10H4.00016C3.29292 10 2.61464 10.281 2.11454 10.781C1.61445
        11.2811 1.3335 11.9594 1.3335 12.6667V14M12.6668 5.33333V9.33333M14.6668 7.33333H10.6668M8.66683
        4.66667C8.66683 6.13943 7.47292 7.33333 6.00016 7.33333C4.5274 7.33333 3.3335 6.13943 3.3335 4.66667C3.3335
        3.19391 4.5274 2 6.00016 2C7.47292 2 8.66683 3.19391 8.66683 4.66667Z"
      stroke="#F7FEE7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
